import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IBusinessAdministratorsResponse } from '../models/business-administrators.model';
import { IGetDirectorsResponse } from '../models/get-directors.model';

export const loadBusinessAdministrators = createAction(
  '[BusinessAdministrators] Load BusinessAdministrators',
  props<{ request: { businessId: string; userRoleIds: string[] } }>()
);

export const loadBusinessAdministratorsSuccess = createAction(
  '[BusinessAdministrators] Load BusinessAdministrators Success',
  props<{ response: IGetDirectorsResponse[] }>()
);

export const loadBusinessAdministratorsFailure = createAction(
  '[BusinessAdministrators] Load BusinessAdministrators Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);

export const clearBusinessAdministrators = createAction('[BusinessAdministrators] Clear BusinessAdministrators');
